<template>
  <section :aria-label="caption" data-testid="logo-cloud">
    <p v-if="caption" v-show="false" class="mb-4 text-sm text-center text-ink-muted">
      {{ caption }}
    </p>
    <ul :class="listClasses">
      <li v-for="logo in logos" :key="logo.name" class="group">
        <span
          class="inline-flex h-10 items-center justify-center rounded-md px-2 text-sm font-semibold uppercase tracking-wide grayscale opacity-70 transition-[filter,opacity] duration-200 group-hover:grayscale-0 group-hover:opacity-100"
          :style="logoShellStyle(logo)"
        >
          <img
            v-if="logo.src"
            :src="logo.src"
            :alt="logo.name"
            width="120"
            height="28"
            loading="lazy"
            decoding="async"
            :class="imgToneClasses"
          />
          <span v-else :class="imgToneClasses">{{ logo.name }}</span>
        </span>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { cva, type VariantProps } from 'class-variance-authority';
import type { LogoCloudItem } from '@/types/component-types';

/** Grayscale на картинке, а не на `<li>`, чтобы `shellBg` оставался цветным. */
const imgToneClasses =
  'h-7 w-auto max-w-[120px] object-contain grayscale opacity-70 transition-[filter,opacity] duration-200 group-hover:grayscale-0 group-hover:opacity-100 md:h-8';

const listVariants = cva('flex flex-wrap items-center justify-center gap-x-10 gap-y-6', {
  variants: {
    tone: {
      default: 'text-ink-muted',
      muted: 'text-ink-muted',
      inverse: 'text-ink-inverse/70',
    },
  },
  defaultVariants: { tone: 'default' },
});

export type LogoCloudTone = NonNullable<VariantProps<typeof listVariants>['tone']>;

export type { LogoCloudItem } from '@/types/component-types';

interface Props {
  logos: readonly LogoCloudItem[];
  tone?: LogoCloudTone;
  caption?: string;
}

const props = withDefaults(defineProps<Props>(), {
  tone: 'default',
});

const listClasses = computed(() => listVariants({ tone: props.tone }));

function logoShellStyle(logo: LogoCloudItem): { backgroundColor: string } | undefined {
  return logo.shellBg ? { backgroundColor: logo.shellBg } : undefined;
}
</script>
